import { render, staticRenderFns } from "./PermissionStore.vue?vue&type=template&id=edfba02a&"
import script from "./PermissionStore.vue?vue&type=script&lang=ts&"
export * from "./PermissionStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports